import { render } from "./ProductPickerQuickView.vue?vue&type=template&id=0bdf5e47"
import script from "./ProductPickerQuickView.vue?vue&type=script&lang=js"
export * from "./ProductPickerQuickView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__